import React from "react";
import CardWithLabel$ from "@deosite/components-new/CardWithLabel";

const CardWithLabel = props => <CardWithLabel$ {...props} />;

export default CardWithLabel;
